import React from 'react';
import { useSession } from '../index';
/**
 * Custom hook to determine if the current user authenticated via OIDC (SSO)
 * @returns boolean indicating if the user is an OIDC user
 */
export const useIsOidcUser = () => {
    const { session } = useSession();
    return React.useMemo(() => {
        if (!session?.authentication_methods) {
            return false;
        }
        return session.authentication_methods.some((method) => method.method === 'oidc');
    }, [session]);
};
